module.exports = __webpack_public_path__ + "img/system_1.51411e3e.png";